var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 316,
    height: 331,
    viewBox: "0 0 316 331",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154.8 256.523C141.607 256.523 129.224 251.358 119.892 242.017C110.56 231.105 105.425 218.722 105.425 205.529C105.425 192.336 110.56 179.952 119.892 172.24L185.936 106.196C193.392 98.7107 197.5 88.7962 197.5 78.2695C197.5 67.7032 193.392 57.7887 185.926 50.343C170.531 34.9478 145.478 34.9182 130.093 50.343C122.608 57.7887 118.5 67.6933 118.5 78.2695H79C79 57.1666 87.2357 37.308 102.186 22.377C132.009 -7.47516 184.001 -7.44554 213.863 22.4165C228.784 37.2981 237 57.1271 237 78.2695C237 99.3723 228.784 119.201 213.853 134.122L147.809 198.537C143.968 202.398 143.968 208.639 147.809 212.5C151.67 216.361 157.911 216.361 161.772 212.5C164.28 209.953 164.666 207.02 164.666 205.479H204.166C204.166 218.672 199.031 231.095 189.699 242.007C180.377 251.349 167.993 256.523 154.8 256.523Z",
    fill: "#B1E4F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_602_177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154 276L142.974 291.793L132.127 276.257C132.468 276.09 132.841 276 133.224 276H154Z",
    fill: "#B1E4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.873 276.257L165.026 291.793L154 276H174.776C175.16 276 175.532 276.089 175.873 276.257Z",
    fill: "#B1E4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.999 291.8H165.027L175.875 276.263H175.876C176.258 276.449 176.599 276.733 176.872 277.098L186.367 289.747C186.813 290.341 187.024 291.074 186.999 291.8Z",
    fill: "#75CEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.999 276L142.973 291.793H165.026L153.999 276Z",
    fill: "#90D8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.973 291.8H121.002C120.977 291.074 121.188 290.341 121.634 289.747L131.129 277.098C131.402 276.733 131.743 276.449 132.125 276.263H132.126L142.973 291.8Z",
    fill: "#E4F6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.025 291.791L154.394 330.965C154.133 331.008 153.865 331.008 153.603 330.965L142.973 291.791H165.025Z",
    fill: "#75CEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.604 330.965C153.013 330.87 152.445 330.559 152.005 330.032C152.003 330.03 152.001 330.027 152 330.026L121.728 293.751C121.724 293.746 121.721 293.741 121.717 293.737C121.263 293.186 121.022 292.492 121.002 291.791H142.973L153.604 330.965Z",
    fill: "#B1E4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.996 291.791C186.976 292.492 186.736 293.186 186.281 293.737C186.277 293.742 186.275 293.746 186.27 293.751L155.999 330.026C155.997 330.028 155.995 330.031 155.994 330.032C155.553 330.559 154.985 330.87 154.395 330.965L165.025 291.791H186.996Z",
    fill: "#6BBEF6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_602_177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 55,
    fill: "white",
    transform: "translate(121 276)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question-mark.69e80e724a1073534c5e601bc0a8297e.svg";
export { ForwardRef as ReactComponent };